import { TenantPackageAddOnGeneric, TenantPackageInclude, TenantPackageIncludes } from '~/tenants/common/package';
import { TwtPackageFloorplanInclude } from '~/tenants/twt/package/common';
import React from 'react';
import TwtPhotoConfig, { TwtPhotoType } from '~/tenants/twt/performable/photo/TwtPhotoConfig';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { format_money } from '~/components/Money';
import { TWT_RENTAL_10, TWT_RENTAL_20 } from '~/tenants/twt/performable/photo/TwtPhotoJob';
import { PackageFormNested, usePackageFormContext } from '~/components/performable/PackageForm';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import { TwtOrderContext } from '~/tenants/twt/model/TwtOrder';
import TwtPhotosNeighborhood from '~/tenants/twt/performable/photo/TwtPhotosNeighborhood';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtPhotosExtra from '~/tenants/twt/performable/photo/TwtPhotosExtra';

export function TwtRentalIncludes({ aerial = false }: { aerial?: boolean }) {
  const context = usePackageFormContext();
  const { metadata } = context.orderContext as TwtOrderContext;

  return (
    <TenantPackageIncludes>
      <TenantPackageInclude name="20 Total Photos (Interior, Exterior & Vignettes)" image="tenant/twt/highlight/1.jpg">
        Highlight special features of your rental property such as barista bars and outdoor recreational spaces
      </TenantPackageInclude>
      <TwtPackageFloorplanInclude />
      {aerial && (
        <TenantPackageInclude name="Aerial Photos" image="tenant/twt/aerial/mini.jpg">
          A bird’s eye view to enhance the marketing of your property
        </TenantPackageInclude>
      )}
    </TenantPackageIncludes>
  );
}

export function TwtRentalPhotos() {
  return (
    <PackageFormNested performable={TwtPhotoConfig}>
      <ZodFieldHidden name="type" value={TwtPhotoType.INTERIOR_EXTERIOR} />
      <TwtPhotosExtra persona={PersonaType.CUSTOMER} />
      <TwtPhotosNeighborhood persona={PersonaType.CUSTOMER} />
    </PackageFormNested>
  );
}
